import { render, staticRenderFns } from "./UserProfileOffcanvas.vue?vue&type=template&id=5bb97213"
import script from "./UserProfileOffcanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileOffcanvas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports